import EditImpactAnalysisDialog from './EditImpactAnalysisDialog';

export default EditImpactAnalysisDialog;
